/* NavigateToExecutionViewAction.js */

"use strict";
const Registrations = require("../Registrations");
class NavToExecViewAction {
    constructor(logger, gameEditor, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }
    run() {
        return this._gameEditor.setActiveView(Registrations.WIZARD_INSTANCE_EDITOR_EXECUTION_VIEW);
    }
}
module.exports = NavToExecViewAction;
module.exports.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.activeView"];
module.exports.$displayDetails = {
    type: "Action",
    name: "NavigateToExecutionViewAction",
    icon: "common.bomb",
    title: "NavigateToExecutionView",
    shown: false,
};
